import ModuleTabs from '@/components/common/ModuleTab';
import { useAppDispatch, useAppSelector } from '@/state/hooks';
import { selectOrderBookWorkspace, setOrderBookWorkspace } from '@/state/reducers/workspaceSlice';
import useLanguage from '@/utils/hooks/useLanguage';
import { Tab } from '@headlessui/react';
import { useMemo } from 'react';
import HorizontalBook from './HorizontalBook';
import VerticalBook from './VerticalBook';

interface OrderBookProps {}

export default function OrderBook(props: OrderBookProps) {
    const dispatch = useAppDispatch();
    const orderBookWorkspace = useAppSelector(selectOrderBookWorkspace);

    const lang = useLanguage();

    const tabs = useMemo(() => {
        return [lang.orderBook.vertical, lang.orderBook.horizontal];
    }, [lang]);

    return (
        <Tab.Group
            defaultIndex={tabs.findIndex((tab) => tab === orderBookWorkspace)}
            onChange={(index) => dispatch(setOrderBookWorkspace(index === 0 ? 'Vertical' : 'Horizontal'))}>
            <div className="h-full flex flex-col" dir={lang.dir}>
                <ModuleTabs.Main tabs={tabs} />
                <Tab.Panel className="flex-1 flex flex-col bg-brand-background overflow-auto">
                    <VerticalBook />
                </Tab.Panel>
                <Tab.Panel className="flex-1 flex flex-col bg-brand-background overflow-auto">
                    <HorizontalBook />
                </Tab.Panel>
            </div>
        </Tab.Group>
    );
}
